module.exports = __webpack_public_path__ + "img/fon-popup.8a7e839f.jpg";